import { inject } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { take } from 'rxjs/operators';
import { PortalAndLineupApplicationConnectionService } from 'src/shared-app-portal/services/portal-and-lineup-application-connection.service';

export const isAuthenticated = (state: RouterStateSnapshot) => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);
  const portalAndLineupApplicationConnectionService = inject(
    PortalAndLineupApplicationConnectionService
  );
  if (
    !state.url.includes('not-found') &&
    !state.url.includes('maintenance-mode') &&
    !state.url.includes('login')
  ) {
    portalAndLineupApplicationConnectionService.setReturnUrl(state.url); // Store the return URL for later use
  }
  return oidcSecurityService.isAuthenticated$.pipe(take(1)).subscribe(({ isAuthenticated }) => {
    // allow navigation if authenticated
    if (isAuthenticated) {
      return true;
    }

    // redirect if not authenticated
    const returnUrl = state.url;
    if (returnUrl.startsWith('/portal/forms/')) {
      portalAndLineupApplicationConnectionService.setFormReturnUrl(returnUrl);
    } else {
      portalAndLineupApplicationConnectionService.removeFormReturnUrl();
    }
    router.navigate(['portal/login'], { queryParams: { returnUrl } });
    return false;
  });
};
